var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6895_9127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2141 11.1366L15.4771 14.3996L14.3996 15.4771L11.1366 12.2141C9.96335 13.1528 8.47543 13.7143 6.85714 13.7143C3.072 13.7143 0 10.6423 0 6.85714C0 3.072 3.072 0 6.85714 0C10.6423 0 13.7143 3.072 13.7143 6.85714C13.7143 8.47543 13.1528 9.96335 12.2141 11.1366ZM10.6855 10.5713C11.6171 9.61112 12.1905 8.30141 12.1905 6.85714C12.1905 3.91048 9.80381 1.52381 6.85714 1.52381C3.91048 1.52381 1.52381 3.91048 1.52381 6.85714C1.52381 9.80381 3.91048 12.1905 6.85714 12.1905C8.30141 12.1905 9.61112 11.6171 10.5713 10.6855L10.6855 10.5713ZM7.75459 3.9438C7.22545 4.18272 6.85714 4.71502 6.85714 5.33333C6.85714 6.17493 7.53935 6.85714 8.38095 6.85714C8.99924 6.85714 9.53158 6.48884 9.77051 5.95971C9.85775 6.24343 9.90476 6.54476 9.90476 6.85714C9.90476 8.54027 8.54027 9.90476 6.85714 9.90476C5.17399 9.90476 3.80952 8.54027 3.80952 6.85714C3.80952 5.17399 5.17399 3.80952 6.85714 3.80952C7.16952 3.80952 7.47086 3.85651 7.75459 3.9438Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6895_9127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.f3eac7f6a940fa5b1ffe3bdd83b20ef2.svg";
export { ForwardRef as ReactComponent };